import api from "../global/Api";
import { ENDPOINTS } from "../global/ApiEndpoints";

export const selectVacuumBreaker = async (vw, dp) => {
  const response = await api.post(`/${ENDPOINTS.VACUUM_BREAKER}`, { vw, dp });
  return response.data;
};
